{
  "familyId": "SWW-TT-ZIJN-HEBBEN",
  "questions": [
    {
      "id": "SWW-TT-ZIJN-HEBBEN-001",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke vorm is correct?\n'Hij ... een grote hond.'",
      "context": null,
      "options": ["heeft", "is", "heb", "zijn"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Zijn vs. Hebben", "content": "Gebruik 'hebben' bij bezit (iets dat je hebt): hij heeft een hond.\nGebruik 'zijn' bij eigenschappen of toestand: hij is groot.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_hebben_bezit",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Je gebruikt 'hebben' als iemand iets bezit. Een hond is iets wat je kunt bezitten, dus: hij heeft een grote hond. 'Zijn' gebruik je voor eigenschappen: hij is groot.",
        "solutionSteps": [
          "Bepaal het onderwerp: hij (enkelvoud)",
          "Vraag: gaat het om bezit of een eigenschap?",
          "Een hond is bezit → gebruik 'hebben'",
          "Bij 'hij' is de vorm: heeft"
        ],
        "distractorExplanations": {
          "0": "Correct! 'Heeft' gebruik je bij bezit: hij heeft een hond.",
          "1": "Je dacht waarschijnlijk dat 'is' hier past. Maar 'is' gebruik je voor eigenschappen of toestand (hij is groot, hij is ziek). Een hond is iets wat je bezit, dus gebruik je 'heeft'. Onthoud: bezit = hebben, eigenschap = zijn.",
          "2": "Je dacht waarschijnlijk dat 'heb' de juiste vorm is. Maar 'heb' gebruik je bij 'ik': ik heb een hond. Bij 'hij' gebruik je 'heeft'. Onthoud: ik heb, jij hebt, hij/zij heeft.",
          "3": "Je dacht waarschijnlijk dat 'zijn' past. Maar 'zijn' is de meervoudsvorm (wij zijn, zij zijn). Bij 'hij' gebruik je 'is' of 'heeft'. Onthoud: hij = enkelvoud, dus niet 'zijn'."
        }
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-002",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke vorm is correct?\n'Zij ... heel blij vandaag.'",
      "context": null,
      "options": ["is", "heeft", "zijn", "heb"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Zijn vs. Hebben", "content": "Gebruik 'zijn' bij eigenschappen, gevoelens en toestanden: zij is blij, hij is ziek, het is koud.\nGebruik 'hebben' bij bezit: zij heeft een fiets.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_hebben_eigenschap",
      "variantIndex": 2,
      "citoDifficulty": 0.15,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Je gebruikt 'zijn' bij gevoelens, eigenschappen en toestanden. 'Blij' is een gevoel/eigenschap, dus: zij is blij. 'Hebben' gebruik je bij bezit.",
        "solutionSteps": [
          "Bepaal het onderwerp: zij (enkelvoud)",
          "Vraag: gaat het om bezit of een eigenschap?",
          "'Blij' is een eigenschap → gebruik 'zijn'",
          "Bij 'zij' (enkelvoud) is de vorm: is"
        ],
        "distractorExplanations": {
          "0": "Correct! 'Is' gebruik je bij eigenschappen en gevoelens: zij is blij.",
          "1": "Je dacht waarschijnlijk dat 'heeft' hier past. Maar 'heeft' gebruik je bij bezit (zij heeft een fiets). 'Blij' is een eigenschap, dus gebruik je 'is': zij is blij. Onthoud: gevoel/eigenschap = zijn.",
          "2": "Je dacht waarschijnlijk dat 'zijn' de juiste vorm is. Maar 'zijn' is de meervoudsvorm (wij zijn blij, zij zijn blij). Bij enkelvoud 'zij' (één persoon) gebruik je 'is'. Onthoud: zij (1 persoon) = is, zij (meerdere) = zijn.",
          "3": "Je dacht waarschijnlijk dat 'heb' past. Maar 'heb' gebruik je bij 'ik': ik heb. Bij 'zij' gebruik je 'is' of 'heeft'. Onthoud: ik heb, jij hebt, hij/zij heeft."
        }
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-003",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct?",
      "context": null,
      "options": [
        "Wij heeft twee katten.",
        "Wij hebben twee katten.",
        "Wij zijn twee katten.",
        "Wij heb twee katten."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Zijn en hebben: alle vormen", "content": "HEBBEN: ik heb, jij hebt, hij/zij/het heeft, wij/jullie/zij hebben\nZIJN: ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_hebben_meervoud",
      "variantIndex": 3,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Bij 'wij' gebruik je 'hebben' (meervoud van hebben). Overzicht: ik heb, jij hebt, hij/zij heeft, wij/jullie/zij hebben. Katten zijn iets wat je bezit, dus gebruik je 'hebben'.",
        "solutionSteps": [
          "Bepaal het onderwerp: wij (meervoud)",
          "Vraag: gaat het om bezit of een eigenschap?",
          "Katten zijn bezit → gebruik 'hebben'",
          "Bij 'wij' is de meervoudsvorm: hebben"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 'heeft' bij 'wij' hoort. Maar 'heeft' gebruik je bij 'hij/zij/het' (enkelvoud). Bij 'wij' gebruik je 'hebben'. Onthoud: wij/jullie/zij → hebben.",
          "1": "Correct! Bij 'wij' gebruik je 'hebben': wij hebben twee katten.",
          "2": "Je dacht waarschijnlijk dat 'zijn' hier past. Maar 'zijn' gebruik je bij eigenschappen/toestand. Katten zijn iets wat je bezit, dus gebruik je 'hebben'. Onthoud: bezit = hebben.",
          "3": "Je dacht waarschijnlijk dat 'heb' bij 'wij' hoort. Maar 'heb' gebruik je bij 'ik': ik heb. Bij 'wij' gebruik je 'hebben'. Onthoud: ik heb, wij hebben."
        }
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-004",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke vorm past in de zin?\n'Ik ... moe na het sporten.'",
      "context": null,
      "options": ["ben", "heb", "is", "zijn"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Zijn: ik ben", "content": "ZIJN: ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn\nMoe is een toestand/eigenschap → gebruik zijn.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_ik_ben",
      "variantIndex": 4,
      "citoDifficulty": 0.15,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'Moe' is een toestand/eigenschap, dus gebruik je 'zijn'. Bij 'ik' is de vorm van 'zijn': ik ben. Dus: ik ben moe.",
        "solutionSteps": [
          "Bepaal het onderwerp: ik",
          "Vraag: gaat het om bezit of een eigenschap?",
          "'Moe' is een toestand → gebruik 'zijn'",
          "Bij 'ik' is de vorm: ben"
        ],
        "distractorExplanations": {
          "0": "Correct! 'Moe' is een toestand, dus gebruik je 'zijn'. Bij 'ik' is dat: ik ben moe.",
          "1": "Je dacht waarschijnlijk dat 'heb' hier past. Maar 'heb' gebruik je bij bezit (ik heb een fiets). 'Moe' is een toestand, dus gebruik je 'ben': ik ben moe. Onthoud: toestand/gevoel = zijn.",
          "2": "Je dacht waarschijnlijk dat 'is' bij 'ik' hoort. Maar 'is' gebruik je bij 'hij/zij/het': hij is moe. Bij 'ik' gebruik je 'ben': ik ben moe. Onthoud: ik ben, hij is.",
          "3": "Je dacht waarschijnlijk dat 'zijn' bij 'ik' hoort. Maar 'zijn' gebruik je bij 'wij/jullie/zij': wij zijn moe. Bij 'ik' gebruik je 'ben': ik ben moe. Onthoud: ik ben, wij zijn."
        }
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-005",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke zin is FOUT?",
      "context": null,
      "options": [
        "Jij hebt een mooie jas.",
        "Hij is ziek.",
        "Wij zijn vrolijk.",
        "Jullie is op vakantie."
      ],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Zijn: alle vormen", "content": "ZIJN: ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn\nBij 'jullie' gebruik je altijd 'zijn', niet 'is'.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_hebben_fout_vinden",
      "variantIndex": 5,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Jullie is op vakantie' is fout. Bij 'jullie' gebruik je 'zijn': jullie zijn op vakantie. De vormen van 'zijn': ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn.",
        "solutionSteps": [
          "Controleer elke zin op de juiste vorm van zijn/hebben",
          "'Jullie is' → jullie is meervoud, maar 'is' is enkelvoud",
          "Bij 'jullie' hoort 'zijn': jullie zijn op vakantie",
          "Antwoord: 'Jullie is op vakantie' is FOUT"
        ],
        "distractorExplanations": {
          "0": "Deze zin is correct: 'jij hebt' is de juiste vorm van 'hebben' bij 'jij'. Onthoud: ik heb, jij hebt, hij heeft.",
          "1": "Deze zin is correct: 'hij is' is de juiste vorm van 'zijn' bij 'hij'. 'Ziek' is een toestand → zijn.",
          "2": "Deze zin is correct: 'wij zijn' is de juiste meervoudsvorm van 'zijn'. 'Vrolijk' is een eigenschap → zijn.",
          "3": "Correct gevonden! 'Jullie is' is fout. Bij 'jullie' gebruik je 'zijn': jullie zijn op vakantie. Onthoud: jullie = meervoud → zijn."
        }
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-006",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "fill_in",
      "question": "Vul de juiste vorm in: 'Wij ... (zijn/hebben) heel veel huiswerk.' Typ het woord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["hebben"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Zijn of hebben?", "content": "Huiswerk is iets wat je bezit/hebt. Bij bezit gebruik je 'hebben'. Bij 'wij' is de vorm: hebben.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_hebben_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Huiswerk is iets wat je hebt (bezit). Bij 'wij' gebruik je de meervoudsvorm: hebben. Dus: wij hebben heel veel huiswerk.",
        "solutionSteps": [
          "Huiswerk = bezit → gebruik 'hebben'",
          "Wij = meervoud → hebben",
          "Antwoord: wij hebben"
        ]
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-007",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "sentence_error_judge",
      "question": "In welke zin staat een fout bij 'zijn' of 'hebben'? Klik op de fout.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "Hij hebben een nieuwe fiets.", "hasError": true, "correction": "heeft", "explanation": "Bij 'hij' (enkelvoud) gebruik je 'heeft', niet 'hebben'. 'Hebben' is de meervoudsvorm." },
          { "text": "Wij zijn heel blij.", "hasError": false },
          { "text": "Ik heb een broer en een zus.", "hasError": false },
          { "text": "Zij is vandaag jarig.", "hasError": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Vervoegingen van hebben", "content": "HEBBEN: ik heb, jij hebt, hij/zij/het heeft, wij/jullie/zij hebben. Bij 'hij' gebruik je 'heeft', niet 'hebben'.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_hebben_error",
      "variantIndex": 7,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "'Hij hebben' is fout. Bij 'hij' (enkelvoud) gebruik je 'heeft': hij heeft een nieuwe fiets. 'Hebben' is de meervoudsvorm (wij/jullie/zij hebben).",
        "solutionSteps": [
          "Hij hebben → FOUT: hij = enkelvoud → heeft",
          "Wij zijn → goed (meervoud + eigenschap)",
          "Ik heb → goed (ik + bezit)",
          "Zij is → goed (enkelvoud + eigenschap)"
        ]
      }
    }
  ]
}